/** @file Session store: whether TK is signed in (from GET /auth/me) and as which actor. */
import type { Actor } from '@pose2d/api/types';
import { createStore } from 'zustand/vanilla';

/** `unknown` until GET /auth/me answers. */
export type SessionStatus = 'unknown' | 'anonymous' | 'signedIn';

/** Actor is null unless signed in. */
export interface SessionState {
  status: SessionStatus;
  actor: Actor | null;
}

/** Written by checkSession/signIn/signOut only. */
export const sessionStore = createStore<SessionState>()(() => ({ status: 'unknown', actor: null }));
